export default __webpack_public_path__ + "static/media/github-logo.ec9ca7bb.svg";